import React from 'react';

const Select = ({ 
  value,
  onChange,
  options = [],
  placeholder = 'Select option',
  disabled = false,
  required = false,
  className = '',
  error = false,
  size = 'md',
  children,
  ...props 
}) => {
  const sizeClasses = size === 'sm' ? 'h-7 px-2 py-1 text-xs' : 'h-10 px-3 py-2';
  const baseClasses = `w-full ${sizeClasses} border rounded-md focus:outline-none transition-colors`;
  
  const stateClasses = {
    normal: 'border-gray-300 focus:ring-2 focus:ring-naviter-blue focus:border-transparent',
    error: 'border-red-300 focus:ring-2 focus:ring-red-500 focus:border-transparent',
    disabled: 'bg-gray-50 text-gray-700 cursor-not-allowed border-gray-300'
  };

  let stateClass;
  if (disabled) {
    stateClass = stateClasses.disabled;
  } else if (error) {
    stateClass = stateClasses.error;
  } else {
    stateClass = stateClasses.normal;
  }

  const classes = `${baseClasses} ${stateClass} ${className}`.trim();

  return (
    <select
      value={value}
      onChange={onChange}
      disabled={disabled}
      required={required}
      className={classes}
      {...props}
    >
      {placeholder && (
        <option value="" disabled={required}>
          {placeholder}
        </option>
      )}
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
      {children}
    </select>
  );
};

export default Select;
